import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import CloseIcon from '@mui/icons-material/Close';
import Container from '@mui/material/Container';
import DialogTitle, { DialogTitleProps } from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface ModalHeaderProps {
  children?: JSX.Element;
  showCloseButton?: boolean;
  DialogTitleProps?: DialogTitleProps;
  title: ReactNode;
  additionalTitleNode?: JSX.Element;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClose?: () => void;
}

const ModalHeader = ({
  children,
  showCloseButton = true,
  DialogTitleProps,
  title,
  additionalTitleNode,
  leftIcon,
  rightIcon,
  onClose,
}: ModalHeaderProps) => {
  const { closeModal } = useMuiModalContext();

  const handleCloseModal = () => {
    closeModal();
    onClose?.();
  };

  return (
    <DialogTitle {...DialogTitleProps}>
      <Stack spacing={3}>
        <Container maxWidth={false} disableGutters>
          <Stack direction="row" alignItems="center" spacing={1}>
            {leftIcon}
            <Stack direction="row" alignItems="center" spacing={3}>
              {typeof title === 'string' ? (
                <Typography variant="h6">{title}</Typography>
              ) : (
                title
              )}
              {additionalTitleNode}
            </Stack>
          </Stack>
          {showCloseButton && (
            <IconButton
              aria-label="close"
              onClick={handleCloseModal}
              sx={{
                position: 'absolute',
                right: 10,
                top: 8,
              }}
            >
              {rightIcon ?? <CloseIcon color="primary" />}
            </IconButton>
          )}
        </Container>
        {children}
      </Stack>
    </DialogTitle>
  );
};

export default ModalHeader;
